import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../services/common-data.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html'
})
export class NotificationComponent implements OnInit {

  constructor(
    public commonDataService : CommonDataService
  ) { }
  notificationObject;
  displayNotification: boolean = false;

  ngOnInit(): void {
    this.commonDataService.notificationObject.subscribe( data => {
      this.notificationObject = data;
      this.showNotification()
    })
  }

  showNotification(){
    if(this.notificationObject.displayTime){
      this.displayNotification = true;
      setTimeout( ()=>{
        this.displayNotification = false;
      }, this.notificationObject.displayTime)
    }
  }

}
